export function farloShare() {
  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(function () {
    document.querySelectorAll('.farlo-share-widget').forEach(function (wrap) {
      var btn = wrap.querySelector('.farlo-ui-share__button');
      var fallback = wrap.querySelector('.farlo-share-widget__fallback');
      var title = wrap.getAttribute('data-share-title') || document.title;
      var url   = wrap.getAttribute('data-share-url') || location.href;
      var text  = wrap.getAttribute('data-share-text') || title;

      var hasFallbacks = fallback && fallback.children && fallback.children.length > 0;

      if (navigator.share && typeof navigator.share === 'function') {
        if (fallback) fallback.style.display = 'none';
        if (btn) btn.addEventListener('click', function () {
          navigator.share({ title: title, text: text, url: url })
            .catch(function (err) {
              if (hasFallbacks && err && err.name !== 'AbortError') {
                fallback.style.display = '';
              }
            });
        }, { passive: true });
      } else {
        if (!hasFallbacks) wrap.style.display = 'none';
        if (btn) btn.style.display = 'none';
        if (fallback) fallback.style.display = '';
      }
    });
  });

}